import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';
import * as Actions from '../../../store/batches/batches.actions';
import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';
// TODO: This code seems dead, maybe kill it?
const initialState = {
  isLoading: false,
  errorOccurred: false,
  hasNameConflict: false,
};

const actionHandlerMap = {
  [Actions.CREATE_BATCH_REQUEST]: (state) => {
    return {
      ...state,
      isLoading: true,
      errorOccurred: false,
      hasNameConflict: false,
    };
  },
  [Actions.CREATE_BATCH_SUCCESS]: (state) => {
    return {
      ...state,
      ...initialState,
    };
  },
  [Actions.CREATE_BATCH_FAILURE]: (state, { error }) => {
    const errors = get(error, 'response.data.Errors', emptyArray);
    const hasNameConflict = !!errors.find((err) => get(err, 'Code') === 1);

    return {
      ...state,
      isLoading: false,
      errorOccurred: true,
      hasNameConflict,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './without-fulfillment-plans.reducer.metadata';
